/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDashboardWidgetData } from '../../../../hooks/useWidgetState'
import ErrorMessage from '../../../share/ErrorMessage'
// eslint-disable-next-line react/prop-types
const CrosstabEmptyResultGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData(widgetId)
  const { t } = useTranslation()

  const metrics = widgetData.data[0].results[0].data.crossTabs.flatMap((entry) => entry.metrics)
  const sum = metrics
    .flatMap((metric) => metric.dataset)
    .flatMap((metricData) => metricData.set)
    .reduce((prev, curr) => prev + curr, 0)
  if (sum === 0) {
    return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>
  }

  return children
}

export default CrosstabEmptyResultGuard
